<h6>{{ environment?.Name }} Services</h6>
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="true"
  [sortable]="true"
  [filterable]="true"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true"
>
  <ng-template kendoGridToolbarTemplate>
    <button class="btn btn-primary" kendoGridAddCommand [hidden]="readonly">
      <fa-icon icon="plus"></fa-icon>
      <!-- Add Service to {{ environment?.Name }} -->
    </button>
  </ng-template>
  <kendo-grid-column
    field="Id"
    title="ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>
  <kendo-grid-column
    field="EnvironmentId"
    title="Environemnt ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>

  <kendo-grid-column field="ServiceId" title="Service">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span>{{ serviceMap[dataItem.ServiceId] }}</span>
    </ng-template>
    <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-isNew="isNew">
      <kendo-dropdownlist
        [formControl]="formGroup.get('ServiceId')"
        [valuePrimitive]="true"
        [data]="services"
        [textField]="'Name'"
        [valueField]="'Id'"
      ></kendo-dropdownlist>
      <div #anch style="height: 1px;"></div>
      <kendo-popup
        [anchor]="anch"
        *ngIf="formGroup.get('ServiceId').invalid && !(isNew && formGroup.get('ServiceId').untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
       >
       <div *ngIf="formGroup.get('ServiceId').hasError('unique')">
        <span class="k-icon k-i-warning"></span>
        Service is already associated with this environment
       </div>         
      </kendo-popup>       
    </ng-template>     
  </kendo-grid-column>
  <kendo-grid-command-column title="" width="120" [hidden]="readonly">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button class="btn btn-danger" kendoGridRemoveCommand>
        <fa-icon icon="trash"></fa-icon>
      </button>
      <button
        class="btn btn-primary"
        kendoGridSaveCommand
        [disabled]="formGroup?.invalid"
      >
        <fa-icon icon="check"></fa-icon>
      </button>
      <button class="btn btn-secondary" kendoGridCancelCommand>
        <fa-icon icon="times"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>
  <div *kendoGridDetailTemplate="let dataItem">
    <app-service-configuration-keys
      [environmentService]="dataItem"
      [tenantEnvironment]="tenantEnvironment"
    ></app-service-configuration-keys>
  </div>
</kendo-grid>
